import { API, Util } from '@odm-operations-tooling/cockpit-commons';
import { getRawToken } from '~/util/authentication';
export const getPermissionRealtimeUrl = () => Util.string.format(API.iamnext.realtime, getRawToken());
